//@ts-nocheck
export class DomMainipulations {
    public static addSvgToAnchorTags($: JQueryStatic): void {
        const svgElement =
            "<svg class='anchor-svg' version='1.1' id='Calque_1' xmlns:x='&ns_extend;' xmlns:i='&ns_ai;' xmlns:graph='&ns_graphs;'x='0px' y='0px' viewBox='0 0 73 3'style='enable-background:new 0 0 73 3;' xml:space='preserve'><style type='text/css'>.svg-anchor-stroke{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}</style><path class='svg-anchor-stroke' d='M1,1c3,3,68-2,71,1'/></svg>";

        $("a").append(svgElement);
        $(".job-page-side-bottom__author").append(svgElement);
    }

    public static navOverlay($: JQueryStatic): void {
        $(".navLevel-1").css("display", "block");

        const navOverlayContainer =
            "<div class='nav-overlay-container'><div class='close-btn'></div>'</div>";

        $(".main-header__navigation .navRoot > .hasChildren").each(function (
            idx,
            val
        ) {
            $(val).prepend(navOverlayContainer);

            const navUl = $(val).find(".navLevel-1").detach();

            $(val).find(".nav-overlay-container").prepend(navUl);
        });
    }

    public static addInstagramFrame($: JQueryStatic): void {
        $(".mb-instagram-banner").each(function (idx, val) {
            const instagramFrame =
                '<div class="instagram-frame"> <div class="instagram-frame__top-container"> <div class="instagram-frame__logo"> <img src="/Blob/img/mbinstalogo.jpg" alt="instagram logo mb"> </div><p class="instagram-frame__name">mbcareers</p><div class="instagram-frame__dots"> <span></span> <span></span> <span></span> </div></div><div class="instagram-frame__image-space"></div><div class="instagram-frame__bottom-container"> <span class="instagram-frame__heart"></span> <span class="instagram-frame__comment"></span> <span class="instagram-frame__message"></span> <span class="instagram-frame__tag"></span> </div></div>';

            $(val).find(".owl-stage-outer").append(instagramFrame);
        });
    }

    public static showEmptyShortlistMessage($: JQueryStatic): void {
        if ($(".shortlist .attrax-vacancy-tile").length === 0) {
            $(".empty-shortlist").css("display", "block");
        }
    }

    public static repostionClearFiltersBtn($: JQueryStatic): void {
        if ($("body.jobs").length > 0) {
            const keyword = $("#keyword-option-wrapper").detach();

            $(".jobs__pagination-wrapper").append(keyword);
        }
    }

    public static repostionContactModal($: JQueryStatic): void {
        const desktopModal = $(
            ".job-details .job-details__recruiter-wrapper--desktop .attrax-popup-modal"
        ).detach();

        $("body").append(desktopModal);
    }

    public static locationDropDownClickHandler($: JQueryStatic): void {
        $(".dynamicformcontrol__wrapper.location > label").on(
            "click",
            function () {
                $(this).parent().find("select").slideToggle();
            }
        );

        $(".dynamicformcontrol__wrapper.location select option").on(
            "click",
            function () {
                $(this).parent().slideUp();
            }
        );
    }

    public static scrollToSections($: JQueryStatic): void {
        // CTA buttons on new regional layout - scrolling to sections

        if ($("body").hasClass("shallow-landing-page")) {
            $(".anchor-btns__btn").on("click", function (e) {
                e.preventDefault();
                const theId = $(this).attr("href");

                if ($(`${theId}`).length) {
                    $("html, body").animate(
                        {
                            scrollTop: $(`${theId}`).offset().top - 70,
                        },
                        1000
                    );
                }
            });
        }
    }

    public static triggerContactMeOnPageLeave($: JQueryStatic): void {
        const nameCheck = $(
            ".job-details .attrax-social-hub-profile-widget__recruiter-name"
        ).attr("href");
        const profileString = "/profile/";

        if (
            $("body").hasClass("job-details") &&
            $(".attrax-social-hub-profile-widget > *").length > 0
        ) {
            $("body").on("mouseleave", function (event) {
                if (
                    event.clientY <= 0 ||
                    event.clientX <= 0 ||
                    event.clientX >= window.innerWidth ||
                    event.clientY >= window.innerHeight
                ) {
                    if (
                        nameCheck === profileString + "harry-kitchen" ||
                        nameCheck === profileString + "sophie-russell" ||
                        nameCheck === profileString + "steph-bull" ||
                        nameCheck === profileString + "steven-miles" ||
                        nameCheck === profileString + "felicity-winsley"
                    ) {
                        return;
                    } else {
                        setTimeout(function () {
                            if (!$("body").hasClass("form-triggered")) {
                                $(
                                    ".attrax-social-hub-profile-widget__message-me-button"
                                ).trigger("click");
                            }

                            $("body").addClass("form-triggered");
                        }, 500);
                    }
                }
            });
        }
    }

    public static ShowOrHidePridePopup($: JQueryStatic): void {
        $(".pride-snip__btn")
            .on("mouseenter", function () {
                $(this).siblings(".pride-snip__popup").addClass("show");
            })
            .on("mouseleave", function () {
                $(this).siblings(".pride-snip__popup").removeClass("show");
            });
    }

    public static moveCarouselReadMoreBtn($: JQueryStatic): void {
        $(".jobs-carousel").each(function (idx, val) {
            const btn = $(val)
                .find(".attrax-list-widget__list > .attrax-button")
                .detach()
                .addClass("list-view-all-btn");

            $(val).find(".attrax-list-widget__lists").append(btn);
        });
    }

    public static hideNavDropdownBanner(): void {
        if (!document.querySelector(".cb-nav-dropdown__wrapper")) {
            return;
        }

        const banner: HTMLElement | null = document.querySelector(
            ".cb-nav-dropdown__wrapper"
        );
        const container: HTMLElement | null = document.querySelector(
            ".cb-nav-dropdown__container"
        );
        const closeBtn: HTMLElement | null = banner.querySelector(
            ".cb-nav-dropdown__close"
        );

        if (container && closeBtn) {
            const pageBody: HTMLElement | null =
                document.getElementById("body");

            const pageHeader: HTMLElement | null =
                document.querySelector(".main-header");

            $(pageBody).addClass("cd-nav-dropdown--active");
            $(pageHeader).addClass("cd-nav-dropdown--active");

            $(banner).addClass("cd-nav-dropdown--active");

            closeBtn.addEventListener("click", () => {
                banner.style.animation =
                    "slide-out 2s cubic-bezier(0.550, 0.085, 0.680, 0.530) both";
                $(pageBody).removeClass("cd-nav-dropdown--active");
                $(pageHeader).removeClass("cd-nav-dropdown--active");
                $(banner).removeClass("cd-nav-dropdown--active");
            });
        }
    }

    public static upOrDownOnScrollWheel($: JQueryStatic): void {
        let lastScrollPos = 0;

        $(window).on("scroll", function () {
            const currentScroll: number = $(this).scrollTop();

            if (currentScroll <= 0 && lastScrollPos < 0) {
                $(".main-header").removeClass("scroll-up");
                $(".main-header").removeClass("scroll-down");
            }

            if (currentScroll > lastScrollPos) {
                $(".main-header").addClass("scroll-down");
                $(".main-header").removeClass("scroll-up");
            } else {
                $(".main-header").addClass("scroll-up");
                $(".main-header").removeClass("scroll-down");
            }

            if (currentScroll === 0) {
                $(".main-header").removeClass("scroll-up");
            }

            lastScrollPos = currentScroll;
        });
    }
}
